module.exports = __webpack_public_path__ + "static/img/four.2e96309c.png";